import { Box, Typography, Link } from "@mui/material";
import { shades } from "../../theme";

const Footer = () => {
  return (
    <Box
      backgroundColor={shades.customDark[500]}
      color="white"
      padding="48px 0 0 0"
      marginTop="auto"
      boxShadow="0 -2px 24px rgba(0,0,0,0.10)"
    >
      <Box
        width="90%"
        maxWidth="1400px"
        margin="0 auto"
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap="wrap"
        gap={4}
        pb={2}
      >
        <Box minWidth={220} mb={3}>
          <Typography
            sx={{
              fontFamily:
                "MSCHFSansMono, monospace, Arial, Helvetica, sans-serif",
              fontWeight: 900,
              fontSize: "22px",
              letterSpacing: "0.13em",
              textTransform: "uppercase",
              textShadow: "0 1px 2px rgba(0,0,0,0.13)",
              WebkitTextStroke: "0.5px rgba(0,0,0,0.13)",
              color: shades.secondary[500],
              mb: 0.5,
            }}
          >
            SHOP APP
          </Typography>
          <Typography
            sx={{
              fontSize: "0.95rem",
              color: shades.neutral[400],
              fontWeight: 400,

              letterSpacing: 0.01,
              mt: 0.5,
              mb: 2,
            }}
          >
            quality products
          </Typography>
        </Box>
        <Box minWidth={180} mb={3}>
          <Typography variant="h6" fontWeight={700} mb={1.5}>
            Quick Links
          </Typography>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Link href="/" color="inherit" underline="hover">
              Home
            </Link>
            <Link href="/products" color="inherit" underline="hover">
              Products
            </Link>
            <Link href="/about" color="inherit" underline="hover">
              About
            </Link>
            <Link href="/contact" color="inherit" underline="hover">
              Contact
            </Link>
          </Box>
        </Box>
        <Box minWidth={180} mb={3}>
          <Typography variant="h6" fontWeight={700} mb={1.5}>
            Customer Service
          </Typography>
          <Box display="flex" flexDirection="column" gap={0.5}>
            <Link href="/shipping" color="inherit" underline="hover">
              Shipping Info
            </Link>
            <Link href="/returns" color="inherit" underline="hover">
              Returns
            </Link>
            <Link href="/faq" color="inherit" underline="hover">
              FAQ
            </Link>
            <Link href="/support" color="inherit" underline="hover">
              Support
            </Link>
          </Box>
        </Box>
        <Box minWidth={220} mb={3}>
          <Typography variant="h6" fontWeight={700} mb={1.5}>
            Connect With Us
          </Typography>
          <Typography variant="body2" mb={0.5}>
            Email:{" "}
            <Link
              href="mailto:cherepenko.iryna@gmail.com"
              color="inherit"
              underline="hover"
            >
              cherepenko.iryna@gmail.com
            </Link>
          </Typography>
          <Typography variant="body2" mb={0.5}>
            GitHub:{" "}
            <Link
              href="https://github.com/Kirspeek"
              color="inherit"
              underline="hover"
              target="_blank"
              rel="noopener"
            >
              @Kirspeek
            </Link>
          </Typography>
          <Typography variant="body2">
            LinkedIn:{" "}
            <Link
              href="https://www.linkedin.com/in/irynacherepenko/"
              color="inherit"
              underline="hover"
              target="_blank"
              rel="noopener"
            >
              irynacherepenko
            </Link>
          </Typography>
        </Box>
      </Box>
      <Box
        width="100%"
        bgcolor={shades.customDark[600]}
        py={2}
        borderTop={`1px solid ${shades.neutral[700]}`}
        textAlign="center"
      >
        <Typography variant="body2" color={shades.neutral[200]}>
          © 2025 Shop App. All rights reserved.
        </Typography>
        <Typography variant="body2" color={shades.neutral[300]} mt={0.5}>
          Created by{" "}
          <Link
            href="https://kirspeek.dev/"
            color={shades.secondary[500]}
            underline="hover"
            target="_blank"
            rel="noopener"
          >
            Kirspeek
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
